'use client';

import { ReactNode } from 'react';

import GeneralLayout from './GeneralLayout';

/**
 * Client-side wrapper for GeneralLayout
 * This component can be safely used in server components like the root layout
 */
interface ClientLayoutWrapperProps {
  children: ReactNode;
}

const ClientLayoutWrapper = ({ children }: ClientLayoutWrapperProps) => {
  return <GeneralLayout>{children}</GeneralLayout>;
};

export default ClientLayoutWrapper;
